import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Components
import {
  TreatmentDiv,
  TitleTextDiv,
  TreatmentText,
  HospitalNameSpan,
  TreatmentInputDiv,
  Label,
  InputCheckboxDiv,
  InputCheckbox,
  VerifyCheckboxImg,
} from "./styles";
// Assets
import CheckTrue from "../../../../assets/icons/ico_checkbox_true.svg";
import CheckFalse from "../../../../assets/icons/ico_checkbox_false.svg";

const Terms = ({ terms, setTerms, termsError, setTermsError }) => {
  const hospitalName = useSelector(({ clinician }) => clinician.data.HOSPITAL_NAME);
  const [t] = useTranslation("global");

  const handleSetTerms = () => {
    setTermsError(false);
    if (!terms) {
      setTerms(true);
    } else {
      setTerms(false);
    }
  };

  const renderPrivacyPolicyText = () => {
    const hospital = <HospitalNameSpan>{hospitalName}</HospitalNameSpan>;

    return (
      <TreatmentText>
        {t("addPatient_personalDataTreatmentText1")} {hospital} {t("addPatient_personalDataTreatmentText2")} {hospital}{" "}
        {t("addPatient_personalDataTreatmentText3")} {hospital} {t("addPatient_personalDataTreatmentText4")} {hospital}
        {". "}
        {t("addPatient_personalDataTreatmentText5")}
      </TreatmentText>
    );
  };

  return (
    <TreatmentDiv>
      <TitleTextDiv>
        <p>{t("addPatient_personalDataTreatmentTitle")}</p>
      </TitleTextDiv>
      {renderPrivacyPolicyText()}
      <TreatmentInputDiv>
        <Label htmlFor="conditions" fontWeight="bold">
          {t("addPatient_conditions")} *
        </Label>
        <InputCheckboxDiv error={termsError}>
          <InputCheckbox type="checkbox" id="conditions" value={terms} onChange={handleSetTerms} />
          {terms ? <VerifyCheckboxImg src={CheckTrue} alt="check-true" /> : <VerifyCheckboxImg src={CheckFalse} alt="check-false" />}
        </InputCheckboxDiv>
      </TreatmentInputDiv>
    </TreatmentDiv>
  );
};

export default Terms;
